import { request } from '@ygtechnologies/bygr-frontend-component-library';
import { ProjectMemberLiteDTO } from '@/types';
import { getCoreApiUrl } from '@/utils/ajax';

export async function getProjectMemberLite(): Promise<ProjectMemberLiteDTO[]> {
    const r = await request(
        `v1/ProjectMember/lite`,
        {
            method: 'GET',
            json: true,
        },
        getCoreApiUrl()
    ).then((response) => response.json());
    return r;
}
